import { render, staticRenderFns } from "./locationMaxAllocationsDialog.vue?vue&type=template&id=03644618&scoped=true"
import script from "./locationMaxAllocationsDialog.vue?vue&type=script&lang=js"
export * from "./locationMaxAllocationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03644618",
  null
  
)

export default component.exports